<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
  <div class="col-md-5 col-lg-4 m-auto text-left px-0">
    <div class="form-group mt-3">
      <!-- <input type="text" class="form-control" placeholder="Select Provider" [(ngModel)]="currentProvider" (keydown.space)="currentProvider.length > 0 ? null : $event.preventDefault()" list="dynmiclist" (ngModelChange)="getCurrentProvider($event)"/>
      <datalist id="dynmiclist">
        <option *ngFor="let currentProvider of energy_providers_list">{{currentProvider}}</option>
      </datalist> -->
      <input [(ngModel)]="currentProvider" (keydown.space)="currentProvider ? null : $event.preventDefault()" (ngModelChange)="getCurrentProvider($event)" [typeahead]="energy_providers_list"
      [typeaheadMinLength]="0" [typeaheadOptionsLimit]="energy_providers_list.length" [typeaheadScrollable] = "true"
      placeholder="Select Provider"class="form-control"/>
      <!-- <select [(ngModel)]="currentProvider" (change)="getCurrentProvider($event)" class="dropdown-toggle form-control">
        <option value="Select Providers" disabled selected>Select Providers</option>
        <option *ngFor="let currentProvider of energy_providers_list" value={{currentProvider}}>{{currentProvider}}</option>
      </select> -->
    </div>
  </div>
  <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
          <div class="arrow_box" >
              <h1 class="questionMob text-left">{{question}}</h1>
          </div>
      </div>
  </div>
  <div class="row m-auto">
      <div class="col-12 form-group float-label-control m-auto">
        <div class="form-group col-12 px-0 mt-2 d-flex flex-wrap" style="margin-bottom:0px !important;">
            <div class="col-3 px-0"></div>
          <div class="col-9 px-0">
              <label for="" class="col-form-label text-right">Select Provider</label>
              <!-- <input type="text" class="form-control focus-none" placeholder="Select Providers" [(ngModel)]="currentProvider" (keydown.space)="currentProvider.length > 0 ? null : $event.preventDefault()" list="dynmiclist" (ngModelChange)="getCurrentProvider($event)"/>
              <datalist id="dynmiclist">
                <option *ngFor="let currentProvider of energy_providers_list" value={{currentProvider}}>{{currentProvider}}</option>
              </datalist> -->
              <input [(ngModel)]="currentProvider" (keydown.space)="currentProvider ? null : $event.preventDefault()" [typeahead]="energy_providers_list"
              [typeaheadMinLength]="0" [typeaheadOptionsLimit]="energy_providers_list.length" [typeaheadScrollable] = "true" (ngModelChange)="getCurrentProvider($event)"
              placeholder="Select Provider"class="form-control"/>
            </div>
        </div>
      </div>
      <div class="col-125" style="width:94% !important; text-align: right;" id="0030_">
        <div *ngIf="user_bot" class="ash_box text-right mt-2 mb-2" >
            <h1 class="ansMob text-right">{{currentProvider}}</h1>
        </div>
      </div>
  </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center">
    <span><img src="assets/images/active28.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
</div> -->